import PropTypes from "prop-types";
import AvatarGroup from "@mui/material/AvatarGroup";
import GrAvatar from "./GrAvatar";
import { gr } from "../tokens";

// A few small overlapping avatars (who liked a post, who sent coins). Each falls back to initials,
// a surface ring separates them, and more people than `max` show as "+N".
export default function GrAvatarGroup({ people = [], max = 2, size = 20, sx }) {
  return (
    <AvatarGroup
      max={max}
      sx={{
        "& .MuiAvatar-root": {
          width: size,
          height: size,
          fontSize: `calc(${size}px * 0.4)`,
          boxSizing: "border-box",
          borderWidth: "1px",
          borderColor: gr.color.surface,
        },
        ...sx,
      }}
    >
      {people.map((person, index) => (
        <GrAvatar
          key={person.id || index}
          size={size}
          name={person.name}
          src={person.src}
        />
      ))}
    </AvatarGroup>
  );
}

GrAvatarGroup.propTypes = {
  people: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      src: PropTypes.string,
    })
  ),
  max: PropTypes.number,
  size: PropTypes.number,
  sx: PropTypes.object,
};
